// Textos de la «experiencia» de la página de inicio: la banda de apertura
// (Hero/HeroSection.jsx), el desarrollo en 4 fotos (HowItWorks.jsx) y la demo
// jugable (GameDemo.jsx).
// Traducción de fr/experience.js — exactamente las mismas claves.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 Usted ya lo sabe. Ellos, todavía no.',

  // El título va en dos líneas, la segunda con degradado.
  'hero.titre.ligne1': 'Haga que descubran',
  'hero.titre.ligne2': 'EL GRAN SECRETO',

  // Frase cortada alrededor del <strong> y de los <br />: la negrita evita el
  // malentendido («no es USTED quien descubre el sexo»).
  'hero.accroche.fort': 'Usted conoce el sexo del bebé. Sus seres queridos, no.',
  'hero.accroche.texte':
    'Este juego se lo hace adivinar: dos equipos, 11 preguntas «¿mamá o papá?», y una última pieza de puzle rascable que se lo anuncia a todos a la vez.',
  'hero.accroche.objet': '📦 Una auténtica caja de juego de cartón, entregada en su casa.',

  'hero.cta.offre': '✨ Descubra nuestra oferta',
  'hero.cta.enSavoirPlus': '↓ Saber más',

  'hero.atout.pieces': '12 piezas, no 1000',
  'hero.atout.joueurs': 'De 2 a 10 jugadores',
  'hero.atout.duree': '20 minutos',

  'hero.imageAlt':
    'Joyful Reveal — juego de gender reveal de Mirum Games: el puzle de los dos ositos, «baby boy» o «baby girl»',
  'hero.scroll': 'Desplácese para descubrir',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'El guion',
  'how.titre': 'Invítelos a cenar. No diga nada.',
  'how.description':
    'Para ellos es una cena como cualquier otra. En el postre, propone un pequeño juego de mesa… y ahí empieza todo. Veinte minutos después, ya lo saben.',

  'how.etape1.titre': '«¿Jugamos a algo?»',
  'how.etape1.texte':
    'La caja llega a la mesa. Cada uno elige su bando —equipo niña o equipo niño— y usted hace la primera de las once preguntas «¿mamá o papá?».',
  'how.etape1.alt':
    'El contenido del juego Joyful Reveal: la caja, la ficha de preguntas y las dos bolsitas',

  'how.etape2.titre': 'Para responder, hay que hacer ruido',
  'how.etape2.texte':
    'Nada de levantar la mano: se cogen juguetes de niños —sonajeros, juguetes que pitan— y se hace el máximo ruido posible. Usted decide qué equipo responde.',
  'how.etape2.alt': 'Las dos bolsitas de tela entregadas a los dos equipos del juego',

  'how.etape3.titre': 'El ambiente sube en crescendo',
  'how.etape3.texte':
    'El equipo que no eligió hace el doble de ruido en la siguiente pregunta. Luego el otro. Cada acierto gana una pieza; con la undécima, todos montan juntos el puzle.',
  'how.etape3.alt':
    'El puzle Joyful Reveal montado en su marco dorado, con la pieza rascable todavía gris',

  'how.etape4.titre': 'La duodécima pieza se rasca',
  'how.etape4.texte':
    'Una última pregunta, un solo ganador. El silencio, y después el grito: el momento que sus seres queridos le contarán durante años.',
  'how.etape4.alt':
    'Una mano rasca con una moneda la última pieza del puzle: aparece la palabra GIRL',

  // Frase final cortada alrededor del enlace: «<enlace> — continuación».
  'how.lienRegles': 'Leer las reglas completas',
  'how.lienReglesSuite': '— preguntas incluidas, listas para imprimir.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Solo para los padres',
  'secret.titre': 'El secreto de los padres',
  'secret.texte':
    'Solo usted conoce las preguntas de antemano, y es usted quien elige qué equipo responde. Así que puede, muy discretamente, echarle una mano a la suerte.',
  'secret.parrain':
    '¿Le gustaría pedirle a alguien que sea padrino o madrina? Dé la palabra a su equipo cuando sepa que él o ella tiene la respuesta. En la final, haga una pregunta cuya respuesta sea un número que le haya confiado unos días antes. Será su mano la que rasque la última pieza.',
  'secret.chute': 'Y la siguiente pregunta la hará usted.',
  'secret.afficher': '👀 Mostrar el secreto (solo para los padres)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Pruébelo ahora — una partida exprés',
  'demo.titre': 'Juegue, como el gran día',
  'demo.intro':
    'Dos equipos, once preguntas, un puzle que se va montando. La duodécima pieza se rasca, y es ella la que lo dice todo. Aquí tiene la partida, en un minuto.',

  // Avisos para lectores de pantalla (aria-live): cada paso de la demo.
  'demo.etape.pari': 'Paso 1 de 4 — forme su equipo',
  'demo.etape.questions': 'Paso 2 de 4 — gane las piezas',
  'demo.etape.cascade': 'Paso 2 de 4 — el puzle se completa',
  'demo.etape.subsidiaire': 'Paso 3 de 4 — la pregunta de desempate',
  'demo.etape.grattage': 'Paso 4 de 4 — la gran revelación',
  'demo.etape.final': 'Partida terminada',
  'demo.aria.resultat': 'Resultado de la demostración: es {mot}.',

  // El sexo sorteado, tal y como encaja en las frases: «¡Es {mot}!»
  'demo.resultat.fille': 'una NIÑA',
  'demo.resultat.garcon': 'un NIÑO',

  'demo.puzzle.aria': 'Puzle de la demostración: {n} pieza(s) colocada(s) de 12',
  'demo.puzzle.pieceAGratter': 'La pieza rascable',
  'demo.puzzle.compteur': '🧩 {n}/12 piezas — la imagen real del puzle (14 × 21 cm)',

  'demo.pari.etiquette': 'Paso 1 — como en las reglas: se forman los equipos',
  'demo.pari.titre': 'Y usted, ¿qué le dice la intuición?',
  'demo.pari.fille': '💗 Apuesto por una NIÑA',
  'demo.pari.garcon': '💙 Apuesto por un NIÑO',
  'demo.pari.note':
    'El gran día, cada uno se une al equipo que le dicta la intuición. Aquí el resultado se sortea; en su casa será su verdadero secreto.',

  'demo.questions.etiquette': 'Pregunta {numero} de 11 — sacada del cuestionario real',
  // Preguntas reales del cuestionario que viene en la caja (números de origen).
  'demo.question.5': '¿Quién cantará las nanas de forma desastrosa?',
  'demo.question.7': '¿Quién llorará con las películas infantiles?',
  'demo.question.11':
    '¿Quién podría despertar al bebé sin querer al pisar un juguete ruidoso?',
  'demo.questions.maman': '🤱 Mamá',
  'demo.questions.papa': '🧔 Papá',
  'demo.questions.gagne': '🧩 ¡Pieza ganada! Se une al puzle…',
  'demo.questions.note':
    'En el juego real son los futuros padres quienes deciden, y hay que responder más rápido que el equipo contrario.',

  'demo.cascade.titre': '…y las otras ocho se ganan igual.',
  'demo.cascade.texte':
    'Pregunta tras pregunta, el puzle se completa; para la demostración se las regalamos. Pronto solo quedará una pieza.',

  'demo.subsidiaire.etiquette':
    'Falta una pieza — la pregunta de desempate decide quién la rasca',
  // La pregunta de la DEMO — deliberadamente DISTINTA de la verdadera pregunta
  // de desempate del juego, para que la portada nunca estropee la sorpresa del
  // gran día. Por eso aquí la demo sí puede dar la respuesta.
  'demo.subsidiaire.question':
    'De media, ¿cuántas horas al día duerme un recién nacido?',
  'demo.subsidiaire.labelEstimation': 'Su estimación del número de horas',
  'demo.subsidiaire.placeholder': 'Su estimación…',
  'demo.subsidiaire.valider': '¡Lo intento!',
  // Frase de respuesta, cortada alrededor del <strong> (la estimación
  // introducida) y del <sup> (el ordinal de «12ª»).
  'demo.subsidiaire.retourAvant': 'Su estimación:',
  'demo.subsidiaire.retourApres':
    '. La respuesta: ¡unas 16 a 17 horas al día! El gran día la pregunta será otra — está impresa en las reglas, con su respuesta 😉.',
  'demo.subsidiaire.retourPiece': 'Quien más se acerque gana la 12',
  'demo.subsidiaire.retourExposant': 'ª',
  'demo.subsidiaire.retourFin': 'pieza. Hoy ese privilegio es suyo.',
  'demo.subsidiaire.cta': '🪙 Rascar la 12ª pieza',

  'demo.grattage.etiquette': 'La 12ª pieza está en sus manos',
  // Las dos líneas pintadas sobre la capa plateada (canvas).
  'demo.grattage.grattez': '✨ RASQUE ✨',
  'demo.grattage.doigtOuSouris': 'dedo o ratón',
  'demo.grattage.aria': 'La pieza está rascada: es {mot}.',
  'demo.grattage.revele': '¡Es {mot}! La pieza se une al puzle…',
  'demo.grattage.revelerMaintenant': 'Revelar ahora mismo',
  'demo.grattage.revelerSansGratter': 'Revelar sin rascar',

  'demo.final.titre': '¡Es {mot}!',
  'demo.final.pariGagne': 'Y su equipo lo había acertado. Respeto.',
  'demo.final.pariPerdu': 'El otro equipo tenía razón — le pasa a los mejores.',
  // Frase cortada alrededor del <strong>: antes / palabra fuerte / después.
  'demo.final.texteAvant': '…en esta demo, al menos. El gran día, será',
  'demo.final.texteFort': 'su',
  'demo.final.texteApres':
    'secreto el que descubrirán sus seres queridos — y el puzle terminado (14 × 21 cm, justo el tamaño de un marco) quedará como recuerdo.',
  'demo.final.ctaBoutique': '🛒 Quiero vivir esto en casa',
  'demo.final.rejouer': '↺ Jugar otra vez',
};
